/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RouteConstants } from '../../config/constants/route';
import { request } from '../../config/helpers/axios-instance';
import { toast } from 'react-toastify';

export default function GenerateReportModal({ onClose }) {
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (!from || !to) return;
        try {
            setIsLoading(true);
            const res = await request({ url: 'report/admin/eazydoseUserOrders', method: 'POST', data: { from, to } });
            if (res?.data?.success) {
                toast.success('Report generation started. Check the Reports page to download.');
                onClose();
                navigate(RouteConstants.REPORTS);
            } else {
                toast.error(res?.data?.error || 'Failed to trigger report');
            }
        } catch {
            toast.error('Failed to trigger report');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='fixed inset-0 bg-black/40 flex items-center justify-center z-50'>
            <div className='bg-white-50 rounded-2xl shadow-xl p-6 w-[380px] flex flex-col gap-4'>
                <h2 className='text-lg font-semibold text-gray-800'>Generate Orders Report</h2>

                <div className='flex flex-col gap-1'>
                    <label className='text-xs font-medium text-gray-500'>From</label>
                    <input
                        type='date'
                        value={from}
                        onChange={(e) => setFrom(e.target.value)}
                        className='border border-gray-300 rounded-lg px-3 py-2 text-sm'
                    />
                </div>

                <div className='flex flex-col gap-1'>
                    <label className='text-xs font-medium text-gray-500'>To</label>
                    <input
                        type='date'
                        value={to}
                        onChange={(e) => setTo(e.target.value)}
                        className='border border-gray-300 rounded-lg px-3 py-2 text-sm'
                    />
                </div>

                <div className='flex gap-2 mt-2'>
                    <button
                        onClick={onClose}
                        className='flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50'
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={!from || !to || isLoading}
                        className='flex-1 px-4 py-2 bg-teal-600 text-white-50 rounded-lg text-sm font-medium disabled:opacity-50'
                    >
                        {isLoading ? 'Generating...' : 'Generate'}
                    </button>
                </div>
            </div>
        </div>
    );
}
